import React from "react";
import FroalaEditor from "react-froala-wysiwyg";
import "froala-editor/css/froala_editor.pkgd.min.css";
import "froala-editor/css/froala_style.min.css";
import "froala-editor/js/plugins.pkgd.min.js";


const CustomEditor = ({ value, setValue, placeholder, ref, title, width }) => {

  const config = {
    // readonly: false,
    key: "re1H1qB1C2D6E7A5E5G4iAa1Tb1YZNYAh1CUKUEQOHFVANUqD1G1F4C3B1C8C7D2C4G4==",
    // askBeforePasteHTML: false,
    // askBeforePasteFromWord: false,
    placeholderText: 'Type a message',
    charCounterCount: false,
    // attribution: false,

    // defaultActionOnPaste: "insert_clear_html",
    // toolbarInlineForSelection: true,
    // toolbar: false,

    direction: "auto",
    tooltips: false,
    // language: "sa",
    // direction: "ltr", // Set the initial direction to left-to-right
    toolbarButtons: {
      // Add the RTL and LTR direction buttons to the toolbar
      moreText: {
        buttons: [
          "bold",
          "italic",
          "underline",
          "strikeThrough",
          "fontSize",
          "textColor",
          "backgroundColor",
          "clearFormatting",
          "alignLeft",
          "alignRight",
          "formatOL",
          "formatUL",
          "quote",
          "insertLink",
          "html",
          "insertTable",
        ],
        buttonsVisible: 14,
      },
      // moreMisc: {
      //   buttons: ["undo", "redo", "fullscreen", "quote", "insertCode", "insertQuote", "insertPre"],
      //   align: "right",
      //   buttonsVisible: 4,
      // },
      direction: {
        // Define the RTL and LTR direction buttons
        icon: "fa fa-align-right",
        title: "Right to Left",
        callback: function () {
          this.direction("rtl"); // Change the editor direction to right-to-left
        },
        undo: true,
      },
      direction2: {
        icon: "fa fa-align-left",
        title: "Left to Right",
        callback: function () {
          this.direction("ltr"); // Change the editor direction to left-to-right
        },
        undo: true,
      },
    },
    events: {
      // Handle the direction change event using the 'change' event
      "froalaEditor.change": function (e, editor) { },
    },
  };


  return (
    <div className="editor-container rounded-lg mt-3">
      {/* Title */}
      {title && (<div className="editor-title text-gray-800 text-base font-medium mb-2 mt-3 mx-3">
        Job Description
      </div>)}

      {/* Editor */}
      <FroalaEditor
        ref={ref}
        tag="textarea"
        model={value}
        // config={config}

        config={{
          ...config,
          wordWrap: true,

          heightMin: 190, // Optional: Set minimum height
          heightMax: 600, // Optional: Set maximum height
        }}
        onModelChange={setValue}
      />
    </div>
  );
};

export default CustomEditor;
